module.exports = __webpack_public_path__ + "img/timer_clock_active.fa391d6f.svg";